document.addEventListener('DOMContentLoaded', () => {
  const quickAddButtons = document.querySelectorAll('.quick-add-btn');
  
  quickAddButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      // Prevent default link behavior to avoid redirecting
      event.preventDefault();

      const variantId = this.getAttribute('data-variant-id');
      const spinner = this.nextElementSibling;

      quickAddToCart(variantId, button, spinner);
    });
  });
});

function quickAddToCart(variantId, button, spinner) {
  if (button.classList.contains('loading')) return; // Prevent duplicate clicks

  button.setAttribute('aria-disabled', true);
  button.classList.add('loading');
  spinner.classList.remove('hidden');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }
      return response.json();
    })
    .then(data => {
      // Update the UI in a lightweight manner
      showNotification('Item added to cart successfully!');
    })
    .catch(error => {
      console.error('Error:', error);
      showNotification('An error occurred while adding the item to the cart.');
    })
    .finally(() => {
      // Only update button states after fetch is complete
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      spinner.classList.add('hidden');
    });
}


function showNotification(message) {
  const notificationToast = document.createElement('div');
  notificationToast.className = 'notification-toast';
  notificationToast.textContent = message;
  document.body.appendChild(notificationToast);

  setTimeout(() => {
    notificationToast.classList.add('fade-out');
  }, 2000);

  setTimeout(() => {
    document.body.removeChild(notificationToast);
  }, 3000);
}
